import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Unit} from '../../dashboard/monitoring/unit';
import {RouteLibraryService} from '../../route/route-library.service';
import {ImmutableListRepositoryService} from '../../../lib/gelios-field/immutable-list-repository.service';
import {Observable, Subscription} from 'rxjs';
import {distinctUntilChanged, distinctUntilKeyChanged, filter, switchMap} from 'rxjs/operators';
import {RouteLibraryEntities} from '../../route/route-library-entity';
import {UnitImageService} from '../../shared/card-view/unit-image.service';

@Component({
  selector: 'app-unit-general-info',
  templateUrl: './unit-general-info.component.html',
  providers: [
    {
      provide: UnitImageService,
      useClass: UnitImageService,
    }
  ]
})
export class UnitGeneralInfoComponent implements OnInit, OnDestroy {
  protected readonly Unit = Unit;
  protected readonly RouteLibraryEntities = RouteLibraryEntities;
  private subscriptions: Subscription[] = [];
  @Input() unitObservable: Observable<Unit>;
  unitModelImage: Observable<{ image: string, title: string }>;
  mileageUntilNextMaintenance = null;

  constructor(
    public routeLibrary: RouteLibraryService,
    public immutableList: ImmutableListRepositoryService,
    protected unitImageService: UnitImageService,
  ) {
  }

  getMileageUntilNextMaintenance(currentMileage, mileageInterval, lastMaintenanceMileage) {
    if (!mileageInterval || !currentMileage) {
      return null;
    }
    lastMaintenanceMileage = typeof lastMaintenanceMileage === 'number' ? lastMaintenanceMileage : lastMaintenanceMileage = 0;
    return Math.round(mileageInterval - (currentMileage - lastMaintenanceMileage));
  }

  ngOnInit() {
    this.subscriptions.push(
      this.unitObservable.pipe(
        filter(unit => !!unit),
        distinctUntilKeyChanged('id')
      ).subscribe(
        unit => {
          this.mileageUntilNextMaintenance = this.getMileageUntilNextMaintenance(
            unit.mileage,
            unit.unitModel.maintenance_interval_mileage,
            unit.last_maintenance_mileage
          );
        }
      )
    );
    this.unitModelImage = this.unitObservable.pipe(
      distinctUntilChanged((x, y) => x.unitModel.id === y.unitModel.id),
      switchMap(unit => this.unitImageService.getUnitModelImage(unit))
    );
  }

  ngOnDestroy() {
    this.subscriptions.filter(s => !!s).forEach(s => s.unsubscribe());
  }
}
